module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/order-53f2620ac409a0cb04dd7750830d37a1.svg";